import type { ComparisonConfig } from './ComparisonPage';

const SITEMINDER_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io مقابل SiteMinder',
  heroSubtitle: 'SiteMinder هو مدير قنوات أسترالي تأسس عام 2006 يركز على توزيع OTA. HotelStack.io يقدم منصة إدارة فنادق متكاملة بـ 36 وحدة مع إدارة قنوات مدمجة و PMS وأغذية ومشروبات وأدوات إيرادات والمزيد — كل ذلك بسعر أقل.',
  overviewComparison: [
    { label: 'نوع المنصة', hotelstack: 'نظام إدارة شامل (36 وحدة)', competitor: 'مدير قنوات + إضافات' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: 'يبدأ من $99+/شهرياً' },
    { label: 'PMS مدمج', hotelstack: 'PMS كامل مشمول', competitor: 'Little Hotelier (منفصل)' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'غير متاح' },
    { label: 'إدارة الإيرادات', hotelstack: 'متقدمة (مدمجة)', competitor: 'قواعد عائد أساسية' },
    { label: 'محرك الحجز', hotelstack: 'BookMyRoom.io (مجاني)', competitor: 'TheBookingButton (إضافة)' },
  ],
  featureTable: [
    { category: 'نظام PMS الأساسي', features: [
      { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: false },
      { name: 'إدارة الحجوزات', hotelstack: true, competitor: 'عبر Little Hotelier' },
      { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: false },
      { name: 'إدارة حساب النزيل', hotelstack: true, competitor: false },
      { name: 'الحجوزات الجماعية', hotelstack: true, competitor: false },
      { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: false },
    ] },
    { category: 'التوزيع وإدارة القنوات', features: [
      { name: 'مدير القنوات (100+ OTA)', hotelstack: true, competitor: true },
      { name: 'اتصال GDS', hotelstack: true, competitor: true },
      { name: 'تكامل البحث الشامل', hotelstack: true, competitor: true },
      { name: 'مراقبة تكافؤ الأسعار', hotelstack: true, competitor: true },
      { name: 'محرك حجز مباشر', hotelstack: true, competitor: 'إضافة مدفوعة' },
    ] },
    { category: 'إدارة الإيرادات', features: [
      { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: 'أساسي' },
      { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
      { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
      { name: 'التنبؤ بالطلب', hotelstack: true, competitor: false },
      { name: 'تحليلات RevPAR', hotelstack: true, competitor: 'أساسي' },
    ] },
    { category: 'النزلاء والعمليات', features: [
      { name: 'ملفات نزلاء شاملة 360 درجة', hotelstack: true, competitor: false },
      { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: false },
      { name: 'محطة نقاط البيع', hotelstack: true, competitor: false },
      { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
      { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
      { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
    ] },
    { category: 'تعدد المنشآت والامتثال', features: [
      { name: 'لوحة تحكم السلسلة', hotelstack: true, competitor: 'محدود' },
      { name: 'تحليلات عبر المنشآت', hotelstack: true, competitor: false },
      { name: 'فوترة متعددة العملات', hotelstack: true, competitor: 'محدود' },
      { name: 'الامتثال الضريبي الإقليمي', hotelstack: true, competitor: false },
      { name: 'إدارة برنامج الولاء', hotelstack: true, competitor: false },
    ] },
    { category: 'المرونة والعمل دون اتصال', features: [
      { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
      { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
      { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
      { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
      { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
    ] },
    { category: 'مبيعات الشركات والمجموعات', features: [
      { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
      { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: false },
      { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
      { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
    ] },
    { category: 'الموظفون والموارد البشرية', features: [
      { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
      { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
      { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
      { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
    ] },
  ],
  pricingComparison: {
    hotelstackStarting: '$49', competitorStarting: '$99+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة — PMS ومدير قنوات ومحرك حجز وأغذية ومشروبات وإدارة إيرادات. تسعير محلي بـ EUR و GBP و AED و INR و THB. تفعيل وترحيل مجاني.',
    competitorNote: 'مدير القنوات من $99+/شهرياً. PMS (Little Hotelier) ومحرك الحجز (TheBookingButton) منتجات منفصلة برسوم منفصلة. لا وحدات أغذية أو عمليات.',
  },
  advantages: [
    'منصة شاملة متكاملة بـ 36 وحدة مقابل نهج SiteMinder كمدير قنوات فقط',
    'PMS كامل مدمج — لا حاجة لشراء Little Hotelier منفصلاً لإدارة المنشأة',
    'أغذية ومشروبات ونقاط بيع وخدمة غرف وإدارة مطبخ مشمولة بدون تكلفة إضافية',
    'إدارة إيرادات متقدمة مع تسعير ديناميكي وتنبؤ ومحاكيات افتراضية',
    'إدارة علاقات النزلاء مع ملفات شاملة وبرامج ولاء وتواصل آلي',
    'أدوات تشغيلية: تدبير منزلي وصيانة وجدولة موظفين متكاملة',
    'سعر بداية أقل ($49 مقابل $99+) مع وظائف أكثر بكثير',
    'تفعيل وترحيل بيانات مجاني مع دعم مخصص على مدار الساعة',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'SiteMinder يتفوق كمدير قنوات مستقل مع اتصال قوي بـ OTA بُني على مدى عقدين تقريباً. لكنه ليس منصة إدارة فنادق متكاملة. HotelStack.io يشمل كل ما يقدمه SiteMinder في التوزيع بالإضافة إلى PMS كامل وأغذية ومشروبات/نقاط بيع وإدارة إيرادات وإدارة علاقات النزلاء و25+ وحدة إضافية — كل ذلك في اشتراك واحد بسعر أقل.',
    bestFor: [
      'الفنادق الراغبة في منصة واحدة بدلاً من تجميع SiteMinder + PMS + POS',
      'المنشآت التي تحتاج PMS كامل وأغذية ومشروبات وأدوات تشغيلية تتجاوز إدارة القنوات',
      'الفنادق الراغبة في إدارة إيرادات متقدمة والتنبؤ بالطلب',
      'المنشآت الصغيرة التي تجد SiteMinder مكلفاً للتوزيع فقط',
      'سلاسل متعددة المنشآت تحتاج إدارة مركزية لجميع العمليات',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من SiteMinder إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا ينقل اتصالات OTA وخطط الأسعار وبيانات الحجز. HotelStack.io يتصل بنفس 100+ OTA التي يدعمها SiteMinder. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون توقف.' },
    { question: 'هل يضاهي HotelStack.io قدرات إدارة القنوات في SiteMinder؟', answer: 'نعم. HotelStack.io يشمل مدير قنوات كامل يتصل بأكثر من 100 OTA و GDS عبر Amadeus و Sabre ومنصات البحث الشامل. مراقبة تكافؤ الأسعار ومزامنة المخزون الفورية ميزات قياسية في كل خطة.' },
    { question: 'لماذا أختار HotelStack.io بدلاً من SiteMinder + Little Hotelier؟', answer: 'شراء SiteMinder (مدير قنوات) بالإضافة إلى Little Hotelier (PMS) و TheBookingButton (محرك حجز) منفصلاً يكلف أكثر بكثير من HotelStack.io مع نقص في الأغذية والمشروبات وإدارة الإيرادات وجدولة الموظفين و20+ وحدة أخرى يشملها HotelStack.io.' },
    { question: 'هل HotelStack.io مناسب للمنشآت الصغيرة التي تستخدم SiteMinder حالياً؟', answer: 'بالتأكيد. خطتنا الأساسية بـ $49/شهرياً تشمل جميع الـ 36 وحدة بدون قيود على الميزات. المنشآت الصغيرة تحصل على منصة إدارة متكاملة بدلاً من مجرد مدير قنوات، بتكلفة إجمالية أقل من SiteMinder وحده.' },
  ],
};

const ROOMRACCOON_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io مقابل RoomRaccoon',
  heroSubtitle: 'RoomRaccoon هو نظام إدارة فنادق هولندي يعمل بالذكاء الاصطناعي يستهدف الفنادق البوتيكية والصغيرة. HotelStack.io يتدرج من البوتيكي إلى المؤسسي بـ 36 وحدة وإدارة إيرادات متقدمة وأغذية ومشروبات/نقاط بيع كاملة ودعم متعدد المنشآت — بأسعار تنافسية.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة متكاملة', competitor: '10+ وحدة' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: 'يبدأ من $79+/شهرياً' },
    { label: 'الشريحة المستهدفة', hotelstack: 'صغيرة إلى مؤسسات كبرى', competitor: 'بوتيكي / فنادق صغيرة' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'غير متاح' },
    { label: 'تعدد المنشآت', hotelstack: 'إدارة سلاسل كاملة', competitor: 'محدود' },
    { label: 'الانتشار العالمي', hotelstack: '40+ دولة', competitor: 'أساساً أوروبا' },
  ],
  featureTable: [
    { category: 'نظام PMS الأساسي', features: [
      { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
      { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
      { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
      { name: 'إدارة حساب النزيل', hotelstack: true, competitor: true },
      { name: 'الحجوزات الجماعية', hotelstack: true, competitor: 'محدود' },
      { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: true },
    ] },
    { category: 'الإيرادات والتوزيع', features: [
      { name: 'مدير القنوات (100+ OTA)', hotelstack: true, competitor: 'عدد أقل من OTA' },
      { name: 'إدارة العائد بالذكاء الاصطناعي', hotelstack: true, competitor: true },
      { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: 'أساسي' },
      { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
      { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
      { name: 'التنبؤ بالطلب', hotelstack: true, competitor: 'أساسي' },
    ] },
    { category: 'إدارة النزلاء', features: [
      { name: 'ملفات نزلاء شاملة 360 درجة', hotelstack: true, competitor: 'أساسي' },
      { name: 'إدارة برنامج الولاء', hotelstack: true, competitor: false },
      { name: 'أتمتة التواصل مع النزلاء', hotelstack: true, competitor: true },
      { name: 'تحليلات إنفاق النزلاء', hotelstack: true, competitor: false },
      { name: 'رفع والتحقق من الهوية', hotelstack: true, competitor: true },
    ] },
    { category: 'الأغذية والمشروبات والعمليات', features: [
      { name: 'محطة نقاط البيع', hotelstack: true, competitor: false },
      { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
      { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
      { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: true },
      { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
      { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
    ] },
    { category: 'المؤسسات وتعدد المنشآت', features: [
      { name: 'لوحة تحكم السلسلة', hotelstack: true, competitor: 'محدود' },
      { name: 'تحليلات عبر المنشآت', hotelstack: true, competitor: false },
      { name: 'إدارة أسعار مركزية', hotelstack: true, competitor: false },
      { name: 'تطبيق معايير العلامة التجارية', hotelstack: true, competitor: false },
      { name: 'مشرف المنصة الأعلى', hotelstack: true, competitor: false },
    ] },
    { category: 'المرونة والعمل دون اتصال', features: [
      { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
      { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
      { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
      { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
      { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
    ] },
    { category: 'مبيعات الشركات والمجموعات', features: [
      { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
      { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'محدود' },
      { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
      { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
    ] },
    { category: 'الموظفون والموارد البشرية', features: [
      { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
      { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
      { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
      { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
    ] },
  ],
  pricingComparison: {
    hotelstackStarting: '$49', competitorStarting: '$79+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة. يتدرج من 10 غرف بوتيكية إلى 500+ غرفة مؤسسية. تسعير محلي بـ EUR و GBP و AED و INR و THB. تفعيل وترحيل مجاني.',
    competitorNote: 'تسعير متدرج من EUR 79+/شهرياً. الميزات المتقدمة مقفلة خلف المستويات الأعلى. قدرات مؤسسية ومتعددة المنشآت محدودة.',
  },
  advantages: [
    'أكثر من ثلاثة أضعاف الوحدات (36 مقابل 10+) بدون ميزات مقفلة خلف مستويات متقدمة',
    'يتدرج من البوتيكي إلى المؤسسي — RoomRaccoon محدود بالمنشآت الصغيرة والمتوسطة',
    'وحدة أغذية ومشروبات كاملة مع نقاط بيع وخدمة غرف وإدارة مطبخ مشمولة',
    'إدارة سلاسل متعددة المنشآت بالكامل مع تحليلات مركزية وتوزيع أسعار',
    'إدارة إيرادات متقدمة تتجاوز العائد الأساسي بالذكاء الاصطناعي — تشمل تنبؤ ومحاكيات',
    'إدارة برنامج ولاء للاحتفاظ بالنزلاء ونمو الحجوزات المتكررة',
    'انتشار عالمي في 40+ دولة مقابل تركيز RoomRaccoon الأوروبي',
    'إدارة موظفين مع جدولة ورواتب وتتبع أداء مشمولة',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'RoomRaccoon خيار جيد للفنادق البوتيكية الأوروبية الصغيرة التي تبحث عن PMS بالذكاء الاصطناعي بواجهة حديثة. لكنه يفتقر للعمق والتوسع والشمولية التشغيلية التي تحتاجها المنشآت النامية. HotelStack.io يقدم كل ما يقدمه RoomRaccoon بالإضافة إلى أغذية ومشروبات/نقاط بيع وإدارة سلاسل مؤسسية وأدوات إيرادات متقدمة وامتثال عالمي — مما يجعله الاستثمار الأقوى على المدى الطويل.',
    bestFor: [
      'الفنادق البوتيكية الراغبة في ميزات مؤسسية بدون أسعار مؤسسية',
      'المنشآت التي تحتاج أغذية ومشروبات ونقاط بيع وإدارة مطبخ في نظامها',
      'الفنادق التي تخطط للتوسع من منشأة واحدة إلى سلاسل متعددة',
      'المنشآت خارج أوروبا التي تحتاج امتثال وتوزيع عالمي',
      'الفنادق الراغبة في إدارة إيرادات متقدمة تتجاوز تحسين العائد الأساسي',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من RoomRaccoon إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا يتولى النقل الكامل للبيانات من RoomRaccoon بما في ذلك ملفات النزلاء وسجل الحجوزات وخطط الأسعار وتكوينات الغرف. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون توقف.' },
    { question: 'هل لدى HotelStack.io ميزات ذكاء اصطناعي مثل RoomRaccoon؟', answer: 'نعم. HotelStack.io يشمل إدارة عائد ذكية وتنبؤ بالطلب وقواعد تسعير ديناميكي ومحاكيات إيرادات. أدواتنا بالذكاء الاصطناعي تتجاوز تحسين العائد الأساسي لتشمل مراقبة المنافسين وتخطيط السيناريوهات الافتراضية.' },
    { question: 'هل HotelStack.io مناسب للفنادق البوتيكية مثل RoomRaccoon؟', answer: 'بالتأكيد. خطتنا الأساسية مصممة لمنشآت بجميع الأحجام بما في ذلك الفنادق البوتيكية. تحصل على جميع الـ 36 وحدة من اليوم الأول بدون قيود، والواجهة الفاخرة الداكنة الحديثة توفر تجربة أنيقة تقدرها المنشآت البوتيكية.' },
    { question: 'كيف يتعامل HotelStack.io مع تعدد المنشآت مقارنةً بـ RoomRaccoon؟', answer: 'HotelStack.io يشمل لوحة إدارة سلاسل كاملة مع تحليلات عبر المنشآت وتوزيع أسعار مركزي ومعايير علامة تجارية وتقارير موحدة. RoomRaccoon لديه دعم محدود لتعدد المنشآت، مما يجعل HotelStack.io الخيار الأفضل لمجموعات الفنادق النامية.' },
  ],
};

const INNROAD_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io مقابل innRoad',
  heroSubtitle: 'innRoad هو نظام PMS سحابي أمريكي للفنادق المستقلة بمجموعة ميزات أساسية. HotelStack.io يقدم 36 وحدة تشمل إدارة إيرادات متقدمة وأغذية ومشروبات/نقاط بيع ودعم متعدد المنشآت وامتثال عالمي — بسعر مماثل.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة متكاملة', competitor: '8+ ميزات أساسية' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: 'يبدأ من $100+/شهرياً' },
    { label: 'تعدد المنشآت', hotelstack: 'إدارة سلاسل كاملة', competitor: 'غير مدعوم' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'غير متاح' },
    { label: 'الانتشار العالمي', hotelstack: '40+ دولة', competitor: 'تركيز أمريكي' },
    { label: 'إدارة الإيرادات', hotelstack: 'متقدمة (مدمجة)', competitor: 'أدوات أسعار أساسية' },
  ],
  featureTable: [
    { category: 'نظام PMS الأساسي', features: [
      { name: 'PMS سحابي', hotelstack: true, competitor: true },
      { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
      { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
      { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
      { name: 'إدارة حساب النزيل', hotelstack: true, competitor: true },
      { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: false },
    ] },
    { category: 'التوزيع والحجز', features: [
      { name: 'مدير القنوات (100+ OTA)', hotelstack: true, competitor: 'عدد محدود من OTA' },
      { name: 'اتصال GDS', hotelstack: true, competitor: true },
      { name: 'محرك حجز بدون عمولة', hotelstack: true, competitor: true },
      { name: 'الحجوزات الجماعية', hotelstack: true, competitor: 'أساسي' },
      { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: 'محدود' },
    ] },
    { category: 'إدارة الإيرادات', features: [
      { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: 'أساسي' },
      { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
      { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
      { name: 'التنبؤ بالطلب', hotelstack: true, competitor: false },
      { name: 'تحليلات RevPAR', hotelstack: true, competitor: 'أساسي' },
    ] },
    { category: 'العمليات والأغذية والمشروبات', features: [
      { name: 'محطة نقاط البيع', hotelstack: true, competitor: false },
      { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
      { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: 'أساسي' },
      { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
      { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
      { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
    ] },
    { category: 'التقارير والامتثال', features: [
      { name: 'تقرير سريع', hotelstack: true, competitor: true },
      { name: 'بيان الأرباح والخسائر', hotelstack: true, competitor: false },
      { name: 'تقرير الوتيرة', hotelstack: true, competitor: false },
      { name: 'فوترة متعددة العملات', hotelstack: true, competitor: false },
      { name: 'الامتثال الضريبي الإقليمي', hotelstack: true, competitor: 'الولايات المتحدة فقط' },
      { name: 'منشئ تقارير مخصصة', hotelstack: true, competitor: false },
    ] },
    { category: 'المرونة والعمل دون اتصال', features: [
      { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
      { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
      { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
      { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
      { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
    ] },
    { category: 'مبيعات الشركات والمجموعات', features: [
      { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: 'محدود' },
      { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: 'أساسي' },
      { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
      { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
    ] },
    { category: 'الموظفون والموارد البشرية', features: [
      { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
      { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
      { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
      { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
    ] },
  ],
  pricingComparison: {
    hotelstackStarting: '$49', competitorStarting: '$100+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة. دعم عملات متعددة عالمياً. تسعير محلي بـ EUR و GBP و AED و INR و THB. تفعيل وترحيل مجاني.',
    competitorNote: 'تسعير حسب العرض من $100+/شهرياً. تركيز أمريكي مع ميزات دولية محدودة. مجموعة ميزات أساسية بدون أغذية ومشروبات أو تعدد منشآت أو تحليلات متقدمة.',
  },
  advantages: [
    'أربعة أضعاف الوحدات (36 مقابل 8+) بما يقارب نصف سعر البداية',
    'إدارة سلاسل متعددة المنشآت بالكامل — innRoad يدعم منشآت مفردة فقط',
    'وحدة أغذية ومشروبات كاملة مع نقاط بيع وخدمة غرف وعرض مطبخ وإدارة قوائم',
    'إدارة إيرادات متقدمة مع تسعير ديناميكي وتنبؤ ومحاكيات',
    'انتشار عالمي في 40+ دولة مقابل تركيز innRoad الأمريكي فقط',
    'فوترة متعددة العملات وامتثال ضريبي إقليمي للمنشآت الدولية',
    'برنامج ولاء وإدارة علاقات نزلاء وتواصل آلي مشمول',
    'تفعيل وترحيل بيانات مجاني مع دعم مخصص على مدار الساعة',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'innRoad هو نظام PMS سحابي مباشر للفنادق الأمريكية المستقلة التي تحتاج إدارة حجوزات ومكتب استقبال أساسية. HotelStack.io يقدم منصة أشمل بكثير بأربعة أضعاف الوحدات ودعم متعدد المنشآت وأغذية ومشروبات/نقاط بيع وأدوات إيرادات متقدمة وانتشار عالمي — كل ذلك بسعر أقل. لأي فندق يخطط للنمو تجاوزاً لاحتياجات PMS الأساسية، HotelStack.io هو الخيار الواضح.',
    bestFor: [
      'الفنادق المستقلة الراغبة في الترقية من PMS أساسي إلى منصة متكاملة',
      'المنشآت التي تحتاج أغذية ومشروبات ونقاط بيع وأدوات تشغيلية يفتقر إليها innRoad',
      'الفنادق المتوسعة دولياً التي تحتاج أدوات عملات متعددة وامتثال',
      'المنشآت الراغبة في إدارة متعددة المنشآت للنمو المستقبلي',
      'الفنادق الباحثة عن إدارة إيرادات متقدمة تتجاوز إعداد الأسعار الأساسي',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من innRoad إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا يتولى النقل الكامل للبيانات من innRoad بما في ذلك ملفات النزلاء وسجل الحجوزات وخطط الأسعار وتكوينات الغرف. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون توقف.' },
    { question: 'هل يدعم HotelStack.io الفنادق الأمريكية المستقلة مثل innRoad؟', answer: 'بالتأكيد. HotelStack.io يدعم الفنادق المستقلة في الولايات المتحدة و40+ دولة أخرى. الفنادق الأمريكية تحصل على جميع الـ 36 وحدة بما في ذلك ميزات يفتقر إليها innRoad مثل الأغذية والمشروبات/نقاط البيع وإدارة الإيرادات ودعم تعدد المنشآت — بدءاً من $49/شهرياً.' },
    { question: 'كيف يقارن HotelStack.io مع innRoad في اتصال GDS؟', answer: 'كلا المنصتين يوفران اتصال GDS عبر Amadeus و Sabre. HotelStack.io يتصل أيضاً بأكثر من 100 OTA عالمياً ويوفر تكامل بحث شامل ويشمل محرك حجز بدون عمولة (BookMyRoom.io) — كل ذلك مشمول في السعر الأساسي.' },
    { question: 'هل يمكن لـ HotelStack.io إدارة منشآت متعددة على عكس innRoad؟', answer: 'نعم. HotelStack.io يشمل إدارة سلاسل كاملة مع لوحة تحكم مركزية وتحليلات عبر المنشآت وتوزيع أسعار مشترك وتطبيق معايير العلامة التجارية وتقارير موحدة. innRoad مصمم لعمليات المنشأة المفردة فقط.' },
  ],
};

const WEBREZPRO_AR: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io مقابل WebRezPro',
  heroSubtitle: 'WebRezPro هو نظام PMS سحابي كندي يركز على المحاسبة ويستهدف الفنادق الصغيرة والمتوسطة. HotelStack.io يقدم منصة حديثة غنية بالميزات بـ 36 وحدة وواجهة مؤسسية وأدوات إيرادات متقدمة وأغذية ومشروبات/نقاط بيع كاملة — مصممة للجيل القادم من الضيافة.',
  overviewComparison: [
    { label: 'إجمالي الوحدات', hotelstack: '36 وحدة متكاملة', competitor: '10+ ميزات أساسية' },
    { label: 'الأسعار', hotelstack: 'يبدأ من $49/شهرياً', competitor: 'يبدأ من $75+/شهرياً' },
    { label: 'جودة الواجهة', hotelstack: 'فاخرة داكنة حديثة', competitor: 'وظيفية / قديمة' },
    { label: 'الأغذية والمشروبات / نقاط البيع', hotelstack: 'مدمج', competitor: 'غير متاح' },
    { label: 'إدارة الإيرادات', hotelstack: 'متقدمة (مدمجة)', competitor: 'أدوات أسعار أساسية' },
    { label: 'تعدد المنشآت', hotelstack: 'إدارة سلاسل كاملة', competitor: 'محدود' },
  ],
  featureTable: [
    { category: 'نظام PMS الأساسي', features: [
      { name: 'PMS سحابي', hotelstack: true, competitor: true },
      { name: 'لوحة الغرف المرئية', hotelstack: true, competitor: true },
      { name: 'إدارة الحجوزات', hotelstack: true, competitor: true },
      { name: 'معالج التدقيق الليلي', hotelstack: true, competitor: true },
      { name: 'إدارة حساب النزيل', hotelstack: true, competitor: true },
      { name: 'بوابة تسجيل الوصول الإلكتروني', hotelstack: true, competitor: false },
    ] },
    { category: 'المحاسبة والمالية', features: [
      { name: 'محاسبة متكاملة', hotelstack: true, competitor: true },
      { name: 'بيان الأرباح والخسائر', hotelstack: true, competitor: true },
      { name: 'حسابات القبض', hotelstack: true, competitor: true },
      { name: 'فوترة متعددة العملات', hotelstack: true, competitor: 'محدود' },
      { name: 'الامتثال الضريبي الإقليمي', hotelstack: true, competitor: 'تركيز على CAD/USD' },
      { name: 'قوالب فواتير مخصصة', hotelstack: true, competitor: true },
    ] },
    { category: 'الإيرادات والتوزيع', features: [
      { name: 'مدير القنوات (100+ OTA)', hotelstack: true, competitor: 'عدد أقل من OTA' },
      { name: 'قواعد التسعير الديناميكي', hotelstack: true, competitor: 'أساسي' },
      { name: 'محاكي الإيرادات الافتراضي', hotelstack: true, competitor: false },
      { name: 'مراقبة أسعار المنافسين', hotelstack: true, competitor: false },
      { name: 'التنبؤ بالطلب', hotelstack: true, competitor: false },
      { name: 'محرك حجز بدون عمولة', hotelstack: true, competitor: true },
    ] },
    { category: 'الأغذية والمشروبات والعمليات', features: [
      { name: 'محطة نقاط البيع', hotelstack: true, competitor: false },
      { name: 'وحدة خدمة الغرف', hotelstack: true, competitor: false },
      { name: 'نظام عرض المطبخ', hotelstack: true, competitor: false },
      { name: 'إدارة التدبير المنزلي', hotelstack: true, competitor: true },
      { name: 'أوامر عمل الصيانة', hotelstack: true, competitor: false },
      { name: 'جدولة الموظفين', hotelstack: true, competitor: false },
    ] },
    { category: 'النزلاء والمؤسسات', features: [
      { name: 'ملفات نزلاء شاملة 360 درجة', hotelstack: true, competitor: 'أساسي' },
      { name: 'إدارة برنامج الولاء', hotelstack: true, competitor: false },
      { name: 'أتمتة التواصل مع النزلاء', hotelstack: true, competitor: 'محدود' },
      { name: 'لوحة تحكم السلسلة', hotelstack: true, competitor: 'محدود' },
      { name: 'تحليلات عبر المنشآت', hotelstack: true, competitor: false },
      { name: 'تطبيق معايير العلامة التجارية', hotelstack: true, competitor: false },
    ] },
    { category: 'المرونة والعمل دون اتصال', features: [
      { name: 'تطبيق ويب تقدمي يعمل دون اتصال', hotelstack: true, competitor: false },
      { name: 'قائمة انتظار التعديلات دون اتصال', hotelstack: true, competitor: false },
      { name: 'مزامنة خلفية عند إعادة الاتصال', hotelstack: true, competitor: false },
      { name: 'تسوية تراعي التعارضات', hotelstack: true, competitor: false },
      { name: 'مكتب استقبال قابل للتثبيت', hotelstack: true, competitor: false },
    ] },
    { category: 'مبيعات الشركات والمجموعات', features: [
      { name: 'إدارة أسعار الشركات', hotelstack: true, competitor: false },
      { name: 'حجز المجموعات مع قوائم الغرف', hotelstack: true, competitor: false },
      { name: 'تقارير أعمار الذمم والإنتاج', hotelstack: true, competitor: false },
      { name: 'حجوزات المطاعم', hotelstack: true, competitor: false },
    ] },
    { category: 'الموظفون والموارد البشرية', features: [
      { name: 'دليل الموظفين وجدولة المناوبات', hotelstack: true, competitor: false },
      { name: 'معالجة الرواتب', hotelstack: true, competitor: false },
      { name: 'الإجازات والحضور', hotelstack: true, competitor: false },
      { name: 'تحليلات الأداء', hotelstack: true, competitor: false },
    ] },
  ],
  pricingComparison: {
    hotelstackStarting: '$49', competitorStarting: '$75+',
    hotelstackNote: 'جميع الـ 36 وحدة مشمولة. واجهة مؤسسية حديثة. تسعير محلي بـ EUR و GBP و AED و INR و THB. تفعيل وترحيل مجاني.',
    competitorNote: 'تسعير حسب الغرفة من $75+/شهرياً بالدولار الكندي. واجهة وظيفية لكن قديمة. أغذية ومشروبات محدودة وتعدد منشآت محدود ودعم أساساً لأمريكا الشمالية.',
  },
  advantages: [
    'أكثر من ثلاثة أضعاف الوحدات (36 مقابل 10+) بواجهة مؤسسية حديثة',
    'وحدة أغذية ومشروبات كاملة مع نقاط بيع وخدمة غرف وإدارة مطبخ مشمولة',
    'إدارة إيرادات متقدمة مع تسعير ديناميكي وتنبؤ ومحاكيات افتراضية',
    'واجهة فاخرة داكنة حديثة مصممة لعام 2026 مقابل واجهة WebRezPro الوظيفية القديمة',
    'إدارة سلاسل متعددة المنشآت بالكامل مع تحليلات مركزية وتوزيع أسعار',
    'انتشار عالمي في 40+ دولة مقابل تركيز WebRezPro على أمريكا الشمالية',
    'برنامج ولاء وإدارة علاقات نزلاء وتواصل آلي للحجوزات المتكررة',
    'تفعيل وترحيل بيانات مجاني مع دعم مخصص على مدار الساعة',
  ],
  verdict: {
    title: 'حكمنا',
    summary: 'WebRezPro هو نظام PMS كندي موثوق بميزات محاسبة قوية للفنادق الصغيرة والمتوسطة في أمريكا الشمالية. لكن واجهته القديمة ومجموعة ميزاته المحدودة وافتقاره للأغذية والمشروبات وأدوات الإيرادات المتقدمة والتوسع المؤسسي يجعله خياراً أقل تنافسية في 2026. HotelStack.io يقدم منصة حديثة شاملة تضاهي WebRezPro في المحاسبة مع إضافة 22+ وحدة إضافية وواجهة عالمية المستوى وقدرات عالمية.',
    bestFor: [
      'الفنادق الراغبة في ترقية واجهة حديثة بدون التضحية بعمق المحاسبة',
      'المنشآت التي تحتاج أغذية ومشروبات ونقاط بيع وإدارة مطبخ تتجاوز PMS الأساسي',
      'الفنادق الباحثة عن إدارة إيرادات متقدمة وأدوات تسعير ديناميكي',
      'المنشآت المتوسعة دولياً تجاوزاً لأمريكا الشمالية',
      'مجموعات الفنادق النامية التي تحتاج إدارة سلاسل متعددة المنشآت بالكامل',
    ],
  },
  faqItems: [
    { question: 'هل يمكنني الترحيل من WebRezPro إلى HotelStack.io؟', answer: 'نعم. فريق الترحيل لدينا يتولى النقل الكامل للبيانات من WebRezPro بما في ذلك ملفات النزلاء وسجل الحجوزات وخطط الأسعار وبيانات المحاسبة وتكوينات الغرف. الترحيل مجاني ويكتمل عادةً خلال 48 ساعة بدون توقف.' },
    { question: 'هل يضاهي HotelStack.io قدرات محاسبة WebRezPro؟', answer: 'نعم. HotelStack.io يشمل محاسبة متكاملة وبيانات أرباح وخسائر وحسابات قبض وفواتير مخصصة وفوترة متعددة العملات. بالإضافة إلى 22+ وحدة إضافية تشمل أغذية ومشروبات وإدارة إيرادات وإدارة علاقات نزلاء وإدارة متعددة المنشآت يفتقر إليها WebRezPro.' },
    { question: 'كيف تقارن واجهة HotelStack.io بواجهة WebRezPro؟', answer: 'HotelStack.io يتميز بواجهة فاخرة داكنة حديثة مبنية بأحدث تقنيات الويب مع تصميم متجاوب عبر جميع الأجهزة. WebRezPro لديه واجهة وظيفية لكن قديمة صُممت لحقبة سابقة من تطبيقات الويب.' },
    { question: 'هل HotelStack.io مناسب للمنشآت الكندية التي تستخدم WebRezPro حالياً؟', answer: 'بالتأكيد. HotelStack.io يدعم الفوترة متعددة العملات بما في ذلك CAD والامتثال الضريبي الكندي (GST/HST/PST) ويتصل بجميع وكالات السفر الإلكترونية الرئيسية في أمريكا الشمالية. العديد من المنشآت الكندية تنتقل للوحدات الإضافية والتجربة الحديثة.' },
  ],
};

export const COMPARISON_AR_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_AR,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_AR,
  'hotelstack-vs-innroad': INNROAD_AR,
  'hotelstack-vs-webrezpro': WEBREZPRO_AR,
};
